/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ClassDayResponse } from './ClassDayResponse';
import {
    ClassDayResponseFromJSON,
    ClassDayResponseFromJSONTyped,
    ClassDayResponseToJSON,
    ClassDayResponseToJSONTyped,
} from './ClassDayResponse';
import type { GetClassRoomResponse } from './GetClassRoomResponse';
import {
    GetClassRoomResponseFromJSON,
    GetClassRoomResponseFromJSONTyped,
    GetClassRoomResponseToJSON,
    GetClassRoomResponseToJSONTyped,
} from './GetClassRoomResponse';
import type { GetLocationResponse } from './GetLocationResponse';
import {
    GetLocationResponseFromJSON,
    GetLocationResponseFromJSONTyped,
    GetLocationResponseToJSON,
    GetLocationResponseToJSONTyped,
} from './GetLocationResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetAvailableClassResponse
 */
export interface GetAvailableClassResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetAvailableClassResponse
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetAvailableClassResponse
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAvailableClassResponse
     */
    slug: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAvailableClassResponse
     */
    imageUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAvailableClassResponse
     */
    description: string | null;
    /**
     * 
     * @type {Array<ClassDayResponse>}
     * @memberof GetAvailableClassResponse
     */
    classDays: Array<ClassDayResponse>;
    /**
     * 
     * @type {any}
     * @memberof GetAvailableClassResponse
     */
    classStartDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetAvailableClassResponse
     */
    classEndDate: any | null;
    /**
     * 
     * @type {string}
     * @memberof GetAvailableClassResponse
     */
    classStartTime: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAvailableClassResponse
     */
    classEndTime: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetAvailableClassResponse
     */
    hasWaitList: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetAvailableClassResponse
     */
    isContinuous: boolean | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetAvailableClassResponse
     */
    maxNumberOfStudents: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetAvailableClassResponse
     */
    currentNumberOfStudents: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {GetClassRoomResponse}
     * @memberof GetAvailableClassResponse
     */
    classRoom: GetClassRoomResponse | null;
    /**
     * 
     * @type {GetLocationResponse}
     * @memberof GetAvailableClassResponse
     */
    location: GetLocationResponse | null;
}

/**
 * Check if a given object implements the GetAvailableClassResponse interface.
 */
export function instanceOfGetAvailableClassResponse(value: object): value is GetAvailableClassResponse {
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('imageUrl' in value) || value['imageUrl'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('classDays' in value) || value['classDays'] === undefined) return false;
    if (!('classStartDate' in value) || value['classStartDate'] === undefined) return false;
    if (!('classEndDate' in value) || value['classEndDate'] === undefined) return false;
    if (!('classStartTime' in value) || value['classStartTime'] === undefined) return false;
    if (!('classEndTime' in value) || value['classEndTime'] === undefined) return false;
    if (!('hasWaitList' in value) || value['hasWaitList'] === undefined) return false;
    if (!('isContinuous' in value) || value['isContinuous'] === undefined) return false;
    if (!('maxNumberOfStudents' in value) || value['maxNumberOfStudents'] === undefined) return false;
    if (!('currentNumberOfStudents' in value) || value['currentNumberOfStudents'] === undefined) return false;
    if (!('classRoom' in value) || value['classRoom'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    return true;
}

export function GetAvailableClassResponseFromJSON(json: any): GetAvailableClassResponse {
    return GetAvailableClassResponseFromJSONTyped(json, false);
}

export function GetAvailableClassResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAvailableClassResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'name': json['name'],
        'slug': json['slug'],
        'imageUrl': json['imageUrl'],
        'description': json['description'],
        'classDays': ((json['classDays'] as Array<any>).map(ClassDayResponseFromJSON)),
        'classStartDate': json['classStartDate'],
        'classEndDate': json['classEndDate'],
        'classStartTime': json['classStartTime'],
        'classEndTime': json['classEndTime'],
        'hasWaitList': json['hasWaitList'],
        'isContinuous': json['isContinuous'],
        'maxNumberOfStudents': ActorActivityRecordActorUserIdFromJSON(json['maxNumberOfStudents']),
        'currentNumberOfStudents': ActorActivityRecordActorUserIdFromJSON(json['currentNumberOfStudents']),
        'classRoom': GetClassRoomResponseFromJSON(json['classRoom']),
        'location': GetLocationResponseFromJSON(json['location']),
    };
}

export function GetAvailableClassResponseToJSON(json: any): GetAvailableClassResponse {
    return GetAvailableClassResponseToJSONTyped(json, false);
}

export function GetAvailableClassResponseToJSONTyped(value?: GetAvailableClassResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'name': value['name'],
        'slug': value['slug'],
        'imageUrl': value['imageUrl'],
        'description': value['description'],
        'classDays': ((value['classDays'] as Array<any>).map(ClassDayResponseToJSON)),
        'classStartDate': value['classStartDate'],
        'classEndDate': value['classEndDate'],
        'classStartTime': value['classStartTime'],
        'classEndTime': value['classEndTime'],
        'hasWaitList': value['hasWaitList'],
        'isContinuous': value['isContinuous'],
        'maxNumberOfStudents': ActorActivityRecordActorUserIdToJSON(value['maxNumberOfStudents']),
        'currentNumberOfStudents': ActorActivityRecordActorUserIdToJSON(value['currentNumberOfStudents']),
        'classRoom': GetClassRoomResponseToJSON(value['classRoom']),
        'location': GetLocationResponseToJSON(value['location']),
    };
}

